<form [formGroup]="tutorBulkActionForm">
<div class="position-relative h-100 d-flex flex-column">
    <app-section-loader [loading]="loading"></app-section-loader>
    <h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">Change Teacher</h2>
    <mat-dialog-content>
        <mat-form-field class="w-100  mb-4" appearance="outline">
            <mat-label>Teacher</mat-label>
            <input matInput formControlName="tutorName" placeholder="Teacher Name" required  name="teacher" [(ngModel)]="teacherName" type="text" pattern="^[^-\s][a-zA-Z0-9_\s-]+$">
            <mat-error *ngIf="tutorBulkActionForm.get('tutorName').hasError('pattern')"> Invalid Teacher Name</mat-error>
        </mat-form-field>
        <p class="modal-text m-0">{{dialogDataInstance?.studentList?.length}} of
            {{dialogDataInstance?.totalStudentsCount}} students
            will be moved to the above teacher's class:</p>
        <div class="list-name-scroll mb-0">
            <ul class="list-unstyled list-name">
                <li *ngFor="let student of dialogDataInstance.studentList"><span class="text">{{student.UserName}}
                    </span></li>
            </ul>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="onCancel();">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="true" [disabled]="!tutorBulkActionForm.valid "
            (click)="confirmAction()">Yes</button>
    </mat-dialog-actions>
</div>
</form>